import { DefaultError } from "@components/error-context"
import { notifications } from "@mantine/notifications"
import { match, P } from "ts-pattern"

const isString = (x: unknown): x is string => typeof x === "string"

const isError = (x: unknown): x is Error => x instanceof Error

export function showErrorNotification(
  e: Error | DefaultError | string | unknown
) {
  const { title, message } = match(e)
    .with(P.when(isString), (x) => ({
      title: "Error",
      message: x,
    }))
    .with(P.when(isError), (x) => ({
      title: x.name,
      message: x.message,
    }))
    .otherwise(() => ({ message: "Unknown Error", title: "" }))

  notifications.show({ message, title, color: "red" })
}

export function showSuccessNotification(message?: string) {
  notifications.show({ message: message, color: "green" })
}
